module.exports = __webpack_public_path__ + "static/img/nav_bg.b133ac86.png";